import React, { useState, useEffect } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import './VocabularyTest.css';

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru';

// ===== КАТЕГОРИЯ ДЛЯ КАЖДОГО УПРАЖНЕНИЯ (ключ exerciseKeys -> категория для отчёта) =====
const EXERCISE_CATEGORY = {
  nouns: 'nouns',                 
  categories_1: 'generalization', 
  categories_2: 'generalization', 
  categories_3: 'generalization', 
  actions: 'actions',             
  professions: 'professions',     
  attributes: 'attributes',       
};

const ITEM_LABELS = {
  dog: 'собака', bear: 'медведь', olen: 'олень', squarel: 'белка',
  sneakers: 'кроссовки', shoes: 'туфли', shorts: 'шорты', dress: 'платье',
  cap: 'чашка', kastryula: 'кастрюля', chair: 'стул', armchair: 'кресло',
  cow: 'корова', koza: 'коза', wolf: 'волк',
  sit: 'сидит', lay: 'лежит', run: 'бежит', stand: 'стоит',
  cook: 'повар', constructor: 'строитель', teacher: 'учитель', doctor: 'врач',
  cake: 'торт', tea: 'чай', ice_cream: 'мороженое', lemon: 'лимон',
};

const ATTRIBUTE_LABELS = {
  tea: 'горячее', ice_cream: 'холодное', cake: 'сладкое', lemon: 'кислое',
};

const GENERALIZATION_LABELS = {
  categories_1: { 1: 'обувь', 2: 'одежда' },
  categories_2: { 1: 'посуда', 2: 'мебель' },
  categories_3: { 1: 'домашние животные', 2: 'дикие животные' },
};

const VocabularyTest = ({ ageGroup, onBack, onComplete }) => {
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();
  const [currentExercise, setCurrentExercise] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [shuffledOptions, setShuffledOptions] = useState([]);

  const shuffleArray = (arr) => {
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const exercises = {
    nouns: {
      data: {
        '4': [
          { id: 1, question: 'Покажи собаку', correct: 'dog', images: { dog: `${S3_BASE_URL}/vocabulary/dog.png`, bear: `${S3_BASE_URL}/vocabulary/bear.png`, olen: `${S3_BASE_URL}/vocabulary/olen.png`, squarel: `${S3_BASE_URL}/vocabulary/squarel.png` }, options: ['dog', 'bear', 'olen', 'squarel'] },
          { id: 2, question: 'Покажи медведя', correct: 'bear', images: { dog: `${S3_BASE_URL}/vocabulary/dog.png`, bear: `${S3_BASE_URL}/vocabulary/bear.png`, olen: `${S3_BASE_URL}/vocabulary/olen.png`, squarel: `${S3_BASE_URL}/vocabulary/squarel.png` }, options: ['dog', 'bear', 'olen', 'squarel'] },
          { id: 3, question: 'Покажи оленя', correct: 'olen', images: { dog: `${S3_BASE_URL}/vocabulary/dog.png`, bear: `${S3_BASE_URL}/vocabulary/bear.png`, olen: `${S3_BASE_URL}/vocabulary/olen.png`, squarel: `${S3_BASE_URL}/vocabulary/squarel.png` }, options: ['dog', 'bear', 'olen', 'squarel'] },
          { id: 4, question: 'Покажи белку', correct: 'squarel', images: { dog: `${S3_BASE_URL}/vocabulary/dog.png`, bear: `${S3_BASE_URL}/vocabulary/bear.png`, olen: `${S3_BASE_URL}/vocabulary/olen.png`, squarel: `${S3_BASE_URL}/vocabulary/squarel.png` }, options: ['dog', 'bear', 'olen', 'squarel'] },
        ],
      }
    },
    categories_1: {
      data: {
        '4': [
          { id: 1, question: 'Покажи ОБУВЬ', correct: ['sneakers', 'shoes'], images: { sneakers: `${S3_BASE_URL}/vocabulary/sneakers.png`, shoes: `${S3_BASE_URL}/vocabulary/shoes.png`, shorts: `${S3_BASE_URL}/vocabulary/shorts.png`, dress: `${S3_BASE_URL}/vocabulary/dress.png` }, options: ['sneakers', 'shoes', 'shorts', 'dress'], type: 'multiple' },
          { id: 2, question: 'Покажи ОДЕЖДУ', correct: ['shorts', 'dress'], images: { sneakers: `${S3_BASE_URL}/vocabulary/sneakers.png`, shoes: `${S3_BASE_URL}/vocabulary/shoes.png`, shorts: `${S3_BASE_URL}/vocabulary/shorts.png`, dress: `${S3_BASE_URL}/vocabulary/dress.png` }, options: ['sneakers', 'shoes', 'shorts', 'dress'], type: 'multiple' },
        ],
      }
    },
    categories_2: {
      data: {
        '4': [
          { id: 1, question: 'Покажи ПОСУДУ', correct: ['cap', 'kastryula'], images: { cap: `${S3_BASE_URL}/vocabulary/big_cup.png`, kastryula: `${S3_BASE_URL}/vocabulary/kastryula.png`, chair: `${S3_BASE_URL}/vocabulary/chair.png`, armchair: `${S3_BASE_URL}/vocabulary/armchair.png` }, options: ['cap', 'kastryula', 'chair', 'armchair'], type: 'multiple' },
          { id: 2, question: 'Покажи МЕБЕЛЬ', correct: ['chair', 'armchair'], images: { cap: `${S3_BASE_URL}/vocabulary/big_cup.png`, kastryula: `${S3_BASE_URL}/vocabulary/kastryula.png`, chair: `${S3_BASE_URL}/vocabulary/chair.png`, armchair: `${S3_BASE_URL}/vocabulary/armchair.png` }, options: ['cap', 'kastryula', 'chair', 'armchair'], type: 'multiple' },
        ],
      }
    },
    categories_3: {
      data: {
        '4': [
          { id: 1, question: 'Покажи ДОМАШНИХ ЖИВОТНЫХ', correct: ['cow', 'koza'], images: { cow: `${S3_BASE_URL}/vocabulary/cow.png`, koza: `${S3_BASE_URL}/vocabulary/goat.png`, wolf: `${S3_BASE_URL}/vocabulary/wolf.png`, olen: `${S3_BASE_URL}/vocabulary/olen.png` }, options: ['cow', 'koza', 'wolf', 'olen'], type: 'multiple' },
          { id: 2, question: 'Покажи ДИКИХ ЖИВОТНЫХ', correct: ['wolf', 'olen'], images: { cow: `${S3_BASE_URL}/vocabulary/cow.png`, koza: `${S3_BASE_URL}/vocabulary/goat.png`, wolf: `${S3_BASE_URL}/vocabulary/wolf.png`, olen: `${S3_BASE_URL}/vocabulary/olen.png` }, options: ['cow', 'koza', 'wolf', 'olen'], type: 'multiple' },
        ],
      }
    },
    actions: {
      data: {
        '4': [
          { id: 1, question: 'Покажи кто СИДИТ?', correct: 'sit', images: { sit: `${S3_BASE_URL}/vocabulary/sit.png`, lay: `${S3_BASE_URL}/vocabulary/lay.png`, run: `${S3_BASE_URL}/vocabulary/run.png`, stand: `${S3_BASE_URL}/vocabulary/stand.png` }, options: ['sit', 'lay', 'run', 'stand'] },
          { id: 2, question: 'Покажи кто ЛЕЖИТ?', correct: 'lay', images: { sit: `${S3_BASE_URL}/vocabulary/sit.png`, lay: `${S3_BASE_URL}/vocabulary/lay.png`, run: `${S3_BASE_URL}/vocabulary/run.png`, stand: `${S3_BASE_URL}/vocabulary/stand.png` }, options: ['sit', 'lay', 'run', 'stand'] },
          { id: 3, question: 'Покажи кто БЕЖИТ?', correct: 'run', images: { sit: `${S3_BASE_URL}/vocabulary/sit.png`, lay: `${S3_BASE_URL}/vocabulary/lay.png`, run: `${S3_BASE_URL}/vocabulary/run.png`, stand: `${S3_BASE_URL}/vocabulary/stand.png` }, options: ['sit', 'lay', 'run', 'stand'] },
          { id: 4, question: 'Покажи кто СТОИТ?', correct: 'stand', images: { sit: `${S3_BASE_URL}/vocabulary/sit.png`, lay: `${S3_BASE_URL}/vocabulary/lay.png`, run: `${S3_BASE_URL}/vocabulary/run.png`, stand: `${S3_BASE_URL}/vocabulary/stand.png` }, options: ['sit', 'lay', 'run', 'stand'] },
        ],
      }
    },
    professions: {
      data: {
        '4': [
          { id: 1, question: 'Покажи кто ГОТОВИТ?', correct: 'cook', images: { cook: `${S3_BASE_URL}/vocabulary/cook.png`, constructor: `${S3_BASE_URL}/vocabulary/constructor.png`, teacher: `${S3_BASE_URL}/vocabulary/teacher.png`, doctor: `${S3_BASE_URL}/vocabulary/doctor.png` }, options: ['cook', 'constructor', 'teacher', 'doctor'] },
          { id: 2, question: 'Покажи кто СТРОИТ?', correct: 'constructor', images: { cook: `${S3_BASE_URL}/vocabulary/cook.png`, constructor: `${S3_BASE_URL}/vocabulary/constructor.png`, teacher: `${S3_BASE_URL}/vocabulary/teacher.png`, doctor: `${S3_BASE_URL}/vocabulary/doctor.png` }, options: ['cook', 'constructor', 'teacher', 'doctor'] },
          { id: 3, question: 'Покажи кто УЧИТ?', correct: 'teacher', images: { cook: `${S3_BASE_URL}/vocabulary/cook.png`, constructor: `${S3_BASE_URL}/vocabulary/constructor.png`, teacher: `${S3_BASE_URL}/vocabulary/teacher.png`, doctor: `${S3_BASE_URL}/vocabulary/doctor.png` }, options: ['cook', 'constructor', 'teacher', 'doctor'] },
          { id: 4, question: 'Покажи кто ЛЕЧИТ?', correct: 'doctor', images: { cook: `${S3_BASE_URL}/vocabulary/cook.png`, constructor: `${S3_BASE_URL}/vocabulary/constructor.png`, teacher: `${S3_BASE_URL}/vocabulary/teacher.png`, doctor: `${S3_BASE_URL}/vocabulary/doctor.png` }, options: ['cook', 'constructor', 'teacher', 'doctor'] },
        ],
      }
    },
    attributes: {
      data: {
        '4': [
          { id: 1, question: 'Покажи что ГОРЯЧЕЕ?', correct: 'tea', images: { cake: `${S3_BASE_URL}/vocabulary/cake.png`, tea: `${S3_BASE_URL}/vocabulary/tea.png`, ice_cream: `${S3_BASE_URL}/vocabulary/ice_cream.png`, lemon: `${S3_BASE_URL}/vocabulary/lemon.png` }, options: ['cake', 'tea', 'ice_cream', 'lemon'] },
          { id: 2, question: 'Покажи что ХОЛОДНОЕ?', correct: 'ice_cream', images: { cake: `${S3_BASE_URL}/vocabulary/cake.png`, tea: `${S3_BASE_URL}/vocabulary/tea.png`, ice_cream: `${S3_BASE_URL}/vocabulary/ice_cream.png`, lemon: `${S3_BASE_URL}/vocabulary/lemon.png` }, options: ['cake', 'tea', 'ice_cream', 'lemon'] },
          { id: 3, question: 'Покажи что СЛАДКОЕ?', correct: 'cake', images: { cake: `${S3_BASE_URL}/vocabulary/cake.png`, tea: `${S3_BASE_URL}/vocabulary/tea.png`, ice_cream: `${S3_BASE_URL}/vocabulary/ice_cream.png`, lemon: `${S3_BASE_URL}/vocabulary/lemon.png` }, options: ['cake', 'tea', 'ice_cream', 'lemon'] },
          { id: 4, question: 'Покажи что КИСЛОЕ?', correct: 'lemon', images: { cake: `${S3_BASE_URL}/vocabulary/cake.png`, tea: `${S3_BASE_URL}/vocabulary/tea.png`, ice_cream: `${S3_BASE_URL}/vocabulary/ice_cream.png`, lemon: `${S3_BASE_URL}/vocabulary/lemon.png` }, options: ['cake', 'tea', 'ice_cream', 'lemon'] },
        ],
      }
    },
  };

  const getQuestions = (data) => data[ageGroup] || data['4'];

  const exerciseKeys = ['nouns', 'categories_1', 'categories_2', 'categories_3', 'actions', 'professions', 'attributes'];
  const currentKey = exerciseKeys[currentExercise];
  const exercise = exercises[currentKey];
  const questions = getQuestions(exercise.data);
  const currentQuestion = questions[currentQuestionIndex];
  const totalQuestions = questions.length;
  const isMultipleChoice = currentQuestion?.type === 'multiple';

  const getAllQuestions = () => {
    let all = [];
    for (const key of exerciseKeys) {
      const qs = getQuestions(exercises[key].data);
      all = [...all, ...qs];
    }
    return all;
  };
  const allQuestions = getAllQuestions();
  const totalAllQuestions = allQuestions.length;

  if (currentQuestion && shuffledOptions.length === 0) {
    setShuffledOptions(shuffleArray(currentQuestion.options));
  }

  // ===== НОВАЯ ФУНКЦИЯ: ПОВТОР ИНСТРУКЦИИ =====
  const repeatQuestion = () => {
    if (!currentQuestion?.question) return;
    stopInstruction();
    playInstruction(currentQuestion.question);
  };

  // ===== ОЗВУЧКА ВОПРОСА =====
  useEffect(() => {
    if (currentQuestion?.question) {
      playInstruction(currentQuestion.question);
    }
  }, [currentExercise, currentQuestionIndex]);

  // ===== ЗАВЕРШЕНИЕ МОДУЛЯ =====
  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        const correctCount = answers.filter((a) => a === true).length;
        const score = Math.round((correctCount / totalAllQuestions) * 100);

        const categoryTotals = {};
        answerLog.forEach(({ category, correct }) => {
          if (!categoryTotals[category]) categoryTotals[category] = { total: 0, correct: 0 };
          categoryTotals[category].total += 1;
          if (correct) categoryTotals[category].correct += 1;
        });
        const byCategory = {};
        Object.entries(categoryTotals).forEach(([cat, { total, correct }]) => {
          byCategory[cat] = Math.round((correct / total) * 100);
        });

        const wordFailures = {};
        answerLog.forEach(({ category, correct, label }) => {
          if (category === 'generalization' || !label) return;
          if (!wordFailures[category]) wordFailures[category] = { correctItems: [], failedItems: [] };
          const bucket = correct ? wordFailures[category].correctItems : wordFailures[category].failedItems;
          if (!bucket.includes(label)) bucket.push(label);
        });

        const generalizationFailures = [];
        answerLog.forEach(({ category, correct, label, missing, extra }) => {
          if (category !== 'generalization' || correct) return;
          generalizationFailures.push({ label, missing, extra });
        });

        if (onComplete) {
          onComplete({
            testId: 'VocabularyTest',
            score,
            details: { total: totalAllQuestions, correct: correctCount, byCategory, wordFailures, generalizationFailures },
          });
        } else {
          onBack();
        }
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);

  const goToNext = () => {
    setIsProcessing(true);
    setTimeout(() => {
      setShuffledOptions([]);
      if (currentQuestionIndex < totalQuestions - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setSelected(null);
      } else {
        if (currentExercise < exerciseKeys.length - 1) {
          setCurrentExercise(currentExercise + 1);
          setCurrentQuestionIndex(0);
          setSelected(null);
        } else {
          setShowResult(true);
        }
      }
      setIsProcessing(false);
    }, 600);
  };

  const recordAnswer = (isCorrect, detail = {}) => {
    setAnswers(prev => [...prev, isCorrect]);
    const category = EXERCISE_CATEGORY[currentKey] || 'other';
    setAnswerLog(prev => [...prev, { category, correct: isCorrect, ...detail }]);
  };

  const handleSelect = (option) => {
    if (isProcessing) return;
    if (selected !== null && !isMultipleChoice) return;

    if (isMultipleChoice) {
      const newSelected = selected && selected.includes(option)
        ? selected.filter((item) => item !== option)
        : selected ? [...selected, option] : [option];

      setSelected(newSelected);

      if (newSelected.length === 2) {
        const correct = currentQuestion.correct;
        const isCorrect = newSelected.length === correct.length && newSelected.every((item) => correct.includes(item));
        const label = GENERALIZATION_LABELS[currentKey]?.[currentQuestion.id] || currentQuestion.question;
        const missing = correct.filter(c => !newSelected.includes(c)).map(c => ITEM_LABELS[c] || c);
        const extra = newSelected.filter(c => !correct.includes(c)).map(c => ITEM_LABELS[c] || c);
        recordAnswer(isCorrect, { label, missing, extra });
        goToNext();
      }
    } else {
      setSelected(option);
      const isCorrect = option === currentQuestion?.correct;
      const labelMap = currentKey === 'attributes' ? ATTRIBUTE_LABELS : ITEM_LABELS;
      const label = labelMap[currentQuestion.correct] || currentQuestion.correct;
      recordAnswer(isCorrect, { label });
      goToNext();
    }
  };

  if (showResult) {
    const correctCount = answers.filter((a) => a === true).length;
    return (
      <ModuleTemplate
        progress={answers}
        totalQuestions={totalAllQuestions}
        forceStop={true}
        onComplete={onComplete || onBack}
      >
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="score-total"> / {totalAllQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  if (!currentQuestion) {
    return (
      <ModuleTemplate
        progress={answers}
        totalQuestions={totalAllQuestions}
        forceStop={true}
        onComplete={onComplete || onBack}
      >
        <div className="loading-text">Загрузка упражнений...</div>
      </ModuleTemplate>
    );
  }

  const displayOptions = shuffledOptions.length > 0 ? shuffledOptions : currentQuestion.options;

  return (
        <ModuleTemplate
      progress={answers}
      totalQuestions={totalAllQuestions}
      forceStop={true}             
      onComplete={onComplete}      
      onRepeat={repeatQuestion}    // ПЕРЕДАЕМ ФУНКЦИЮ ПОВТОРА ВНИЗ
      extraContent={currentQuestion.question}
    >
      <div className="vocabulary-container">

        <div className="vocabulary-images-grid">
          {displayOptions.map((key) => {
            const isSelected = isMultipleChoice ? selected && selected.includes(key) : selected === key;
            return (
              <button
                key={key}
                className={`vocabulary-image-btn ${isSelected ? 'selected-multiple' : ''}`}
                onClick={() => handleSelect(key)}
              >
                <img
                  src={currentQuestion.images[key]}
                  alt=""
                  className="vocabulary-image"
                  onError={(e) => {
                    e.target.src = '/placeholder.png';
                  }}
                />
              </button>
            );
          })}
        </div>
      </div>
    </ModuleTemplate>
  );
};

export default VocabularyTest;